import { connect } from "react-redux";

import api from "api";
import SendResetPassword from "components/SendResetPassword";
import { changeForm, init, setErrors } from "redux/modules/sendResetPassword";
import { openErrorDialog } from "redux/modules/errorDialog";
import { showSnackbar } from "redux/modules/snackbar";

const mapStateToProps = state => {
  return { ...state.sendResetPassword };
};

const mapDispatchToProps = dispatch => ({
  changeForm: (key, value) => {
    dispatch(changeForm(key, value));
  },
  handleSubmit: (customerId, loginId, isAdmin) => {
    const errors = [];

    if (!isAdmin && !customerId) {
      errors.push("顧客IDを入力してください。");
    }

    if (!loginId) {
      errors.push(`${isAdmin ? "管理者ID" : "担当者ID"}を入力してください。`);
    }

    if (errors.length > 0) {
      dispatch(setErrors(errors));
      return;
    }

    const params = {
      customerId,
      loginId
    };

    api
      .post("send_password_reset_mail", params)
      .then(() => {
        dispatch(init());
        dispatch(showSnackbar("メールを送信しました。"));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  init: () => dispatch(init())
});

export default connect(mapStateToProps, mapDispatchToProps)(SendResetPassword);



// WEBPACK FOOTER //
// ./src/containers/SendResetPassword/index.js